module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_tvb-33397342005927dbf9bae8c9f8a775d7.webp";